<template>
    <form>
        <div class="form-row">
            <div class="col-4">
                <label for="user">User Name</label>
                <input
                    v-model="t_userName"
                    type="text"
                    class="form-control"
                    id="user"
                    placeholder="User Name"
                    title="Eindeutige Bezeichnung des Users"
                    autocomplete="username"
                    @keydown.enter.prevent
                >
            </div>
        </div>
        <div class="form-row">
            <div class="col-4">
                <label for="password">Passwort</label>
                <input
                    v-model="t_password"
                    type="password"
                    class="form-control"
                    id="password"
                    placeholder="Passwort"
                    title="Passwort"
                    autocomplete="new-password"
                    @keydown.enter.prevent
                >
            </div>
        </div>
        <div class="form-row">
            <div class="col-4">
                <label for="passwordConfirmation">Passwort wiederholen</label>
                <input
                    v-model="t_passwordConfirmation"
                    type="password"
                    class="form-control"
                    id="passwordConfirmation"
                    placeholder="Passwort wiederholen"
                    title="Passwort wiederholen"
                    autocomplete="new-password"
                    @keydown.enter.prevent
                >
            </div>
        </div>
        <div class="form-row">
            <div class="col-4">
                <label for="commonName">User Beschreibung</label>
                <input
                    v-model="t_commonName"
                    type="text"
                    class="form-control"
                    id="commonName"
                    placeholder="User Beschreibung"
                    title="Gängige Beschreibung oder Name des Users"
                    @keydown.enter.prevent
                >
            </div>
        </div>
        <div class="form-row">
            <div class="col-4">
                <label for="groupMembership">Gruppe</label>
                <select
                    v-model="t_groupMembership"
                    class="custom-select"
                    title="Mitglieder dieser Gruppe"
                    id="groupMembership">
                    <option value=0 selected>Gruppe auswählen...</option>
                    <option v-for="item_name in user_group_list" :key="item_name" :value="item_name">
                        {{ item_name }}
                    </option>
                    
                </select>
            </div>
        </div>
        <div class="form-row d-flex justify-content-end">
            <div class="p-0">
                <a v-on:click="perform('SAVE')" v-on:submit.prevent="onSubmit" class="btn btn-success" href="#" role="button">
                    User speichern
                </a>
            </div>
        </div>
        
    </form>
</template>

<script>
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import {en, de} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'AddUser',
    components: {
        Datepicker
    },
    data() {
        return {
            error_msg: 'No Error',
            t_userName: '',
            t_commonName: '',
            t_groupMembership: '',
            t_password: '',
            t_passwordConfirmation: '',
            en: en,
            de: de,
        }
    },
    methods: {
        perform(actionType) {
            if (confirm('User speichern?')) {
                var msg = {type: "NONE"}
                if (this.t_password != this.t_passwordConfirmation) {
                    msg = {
                        message: "Die Passwörter stimmen nicht überein!",
                        type: "ERROR"
                    }
                    this.$store.commit('add_message', msg)
                    return
                }

                const data = new FormData();
                data.append('userName', this.t_userName)
                data.append('commonName', this.t_commonName)
                data.append('groupMembership', this.t_groupMembership)
                data.append('actionType', actionType)
                data.append('password', this.t_password)
                // eslint-disable-next-line
                console.log( this.t_date);
                var credentials = JSON.parse(localStorage.getItem('credentials'))
                
                axios({
                    url: process.env.VUE_APP_ROOT_API
                        + '/users',
                    data: data,
                    auth: credentials,
                    method: 'post'
                })
                .catch(e => {
                    // eslint-disable-next-line
                    console.log(e);
                })
                .then(resp => {
                    msg = resp.data
                    // eslint-disable-next-line
                    console.log("Message")
                    // eslint-disable-next-line
                    console.log(msg)
                    if (!(msg.type == "NONE")) {
                        // eslint-disable-next-line
                        console.log("Pushing error")
                        this.$store.commit('add_message', msg)
                    } else if (!(msg.type == "ERROR")) {
                        this.t_userName = ''
                        this.t_commonName = ''
                        this.t_groupMembership = ''
                    }
                });
                this.$store.dispatch('loadData')
            }
            
        }
    },
    computed: {
        accountName () {
            return this.$store.state.current_acc
        },
        user_group_list() {
            var group_names = []
            this.$store.state.group_list.groups.forEach(group => {
                group_names.push(group.name)
            });
            return group_names
        }
    }
}
</script>

<style scoped>

</style>

